import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const useAdminAutoLogout = (timeout = 15 * 60 * 1000, warningTime = 60 * 1000) => {
  const [warningVisible, setWarningVisible] = useState(false);
  const logoutTimer = useRef(null);
  const warningTimer = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const checkTokenExpiry = () => {
      const expiry = localStorage.getItem('adminTokenExpiry');
      if (!expiry || Date.now() > Number(expiry)) {
        localStorage.removeItem('adminToken');
        localStorage.removeItem('adminTokenExpiry');
        localStorage.removeItem('adminUser');
        alert('Session expired. Please log in again.');
        navigate('/admin/login');
        return true;
      }
      return false;
    };

    const startTimers = () => {
      if (checkTokenExpiry()) return;

      clearTimeout(logoutTimer.current);
      clearTimeout(warningTimer.current);
      setWarningVisible(false);

      // ⏳ Show warning 1 minute before logout
      warningTimer.current = setTimeout(() => {
        setWarningVisible(true);

        // 🛑 Final logout trigger
        logoutTimer.current = setTimeout(() => {
          localStorage.removeItem('adminToken');
          localStorage.removeItem('adminTokenExpiry');
          localStorage.removeItem('adminUser');
          alert('Auto logout: Session inactive.');
          navigate('/admin/login');
        }, warningTime);
      }, timeout - warningTime);
    };

    const activityEvents = ['mousemove', 'keydown', 'click', 'scroll'];
    activityEvents.forEach(event => window.addEventListener(event, startTimers));

    startTimers(); // Kick off timers

    return () => {
      activityEvents.forEach(event => window.removeEventListener(event, startTimers));
      clearTimeout(logoutTimer.current);
      clearTimeout(warningTimer.current);
    };
  }, [navigate, timeout, warningTime]);

  return { warningVisible };
};

export default useAdminAutoLogout;
